import { render, staticRenderFns } from "./crearRompecabezas.vue?vue&type=template&id=c19b31d0"
import script from "./crearRompecabezas.vue?vue&type=script&lang=js"
export * from "./crearRompecabezas.vue?vue&type=script&lang=js"
import style0 from "./crearRompecabezas.vue?vue&type=style&index=0&id=c19b31d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports